<template>
    <bottom-sheet v-model="shows" title="매칭 채용여부 확인" fullscreen persistent width="1080" maxWidth="95%" needsLogin>
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on, loading }" />
        </template>
        <v-layout column justify-center class="bottom-sheet__contents h-100">
            <template v-if="loading">
                <v-overlay absolute color="white">
                    <v-progress-circular indeterminate size="100" width="5" color="primary" />
                </v-overlay>
            </template>
            <template v-else>
                <div v-if="step == STEPS.RESULTS.value" class="d-flex flex-column">
                    <v-sheet class="d-flex flex-column align-center">
                        <i class="icon icon-check mb-20 mb-lg-40"></i>
                        <v-sheet class="text-center mb-20 mb-lg-40">
                            <h3 class="tit mb-8 mb-lg-16">
                                <span> 매칭 채용응답 완료 </span>
                            </h3>
                            <p class="page-text--lg grey-6--text">
                                <span> 매칭 채용응답이 완료되었습니다. </span>
                            </p>
                        </v-sheet>
                        <div class="v-btn-group mt-0">
                            <v-btn color="primary" class="min-w-140px min-w-lg-160px" @click="exit"><span>확인</span></v-btn>
                        </div>
                    </v-sheet>
                </div>
                <div v-else class="d-flex flex-column fill-height justify-center">
                    <div class="text-center mb-20 mb-lg-40">
                        <h3 class="tit mb-8 mb-lg-16">매칭 채용여부 확인</h3>
                        <p class="page-text--lg grey-6--text">
                            채용여부 및 사유를 작성해주세요. <br />
                            사유는 채용기업과 프로그램 관리자만 내용확인 가능합니다.
                        </p>
                    </div>
                    <common-btns v-model="form" @input="emit" class="mb-20 mb-lg-40" style="flex: 0 1 auto" />
                    <v-sheet class="scroll-primary pr-10" style="flex: 0 1 auto; overflow-y: auto; overflow-x: hidden">
                        <v-expand-transition>
                            <vertical-form-table v-model="form" v-show="form.isSuccess" v-bind="{ items }" @input="emit" />
                        </v-expand-transition>
                    </v-sheet>
                    <div class="v-btn-group" style="flex: 0 1 auto">
                        <v-btn outlined color="grey-d" class="min-w-140px min-w-lg-160px" @click="exit">
                            <span class="grey-6--text"> 취소하기 </span>
                        </v-btn>
                        <v-btn color="primary" class="min-w-140px min-w-lg-160px" @click="save">
                            <span> 응답하기 </span>
                        </v-btn>
                    </div>
                </div>
            </template>
        </v-layout>
    </bottom-sheet>
</template>

<script>
import api from "@/api";
import { initExpoMatching, initExpoProgram } from "@/assets/variables/inits";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import CommonBtns from "./common/common-btns.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import { attrs_input } from "@/assets/variables";

const STEPS = {
    RESPOND: { value: "RESPOND", text: "응답" },
    RESULTS: { value: "RESULTS", text: "결과" },
};

const steps = Object.values(STEPS).map((item, index) => ({ ...item, step: index + 1 }));

const items = [
    {
        ...attrs_input,
        key: "employMsg",
        term: "채용사유",
        type: "textarea",
        required: true,
    },
];

export default {
    components: {
        BottomSheet,
        CommonBtns,
        VerticalFormTable,
    },
    props: {
        value: { type: Object, default: initExpoMatching },
        program: { type: Object, default: initExpoProgram },

        isSuccess: { type: Boolean, default: undefined },
    },
    data: () => ({
        form: initExpoMatching(),

        shows: false,
        loading: false,
        updated: false,

        step: steps[0].value,
        steps,
        STEPS,
        items,
    }),
    computed: {
        _program() {
            return this.program._id;
        },
    },
    methods: {
        async init() {
            this.updated = false;
            this.loading = false;
            this.step = steps[0].value;

            if (this.loading) return;
            else this.loading = true;

            try {
                let { matching } = await api.v1.company.expo.matchings.get({
                    _id: this.value._id,
                });
                if (this.isSuccess !== undefined) {
                    matching.isSuccess = this.isSuccess;
                }
                this.form = initExpoMatching(matching);
            } finally {
                this.loading = false;
            }
        },
        async exit() {
            this.shows = false;
        },
        async next() {
            if (!this.validate()) return;

            let index = this.steps.findIndex(({ value }) => value == this.step);
            this.step = this.steps[index + 1]?.value;
        },
        async prev() {
            let index = this.steps.findIndex(({ value }) => value == this.step);
            this.step = this.steps[index - 1]?.value;
        },
        async save() {
            if (!this.validate()) return;

            if (this.loading) return;
            else this.loading = true;
            try {
                let { ...form } = this.form;

                let { matching } = await api.v1.company.expo.matchings.put(form);
                this.form = initExpoMatching(matching);
                this.updated = true;
                this.next();
            } finally {
                if (this.loading) this.loading = false;
            }
        },

        emit() {
            this.form = initExpoMatching(this.form);
        },

        validate() {
            try {
                switch (this.step) {
                    case STEPS.RESPOND.value: {
                        if (this.form.isGranted) {
                            if (!this.form.interviewAt) {
                                throw new Error("면접 시간을 선택해주세요");
                            }
                        }
                        //
                        else {
                            if (!this.form.refuseMsg) {
                                throw new Error("거부 사유를 작성해주세요");
                            }
                        }
                        break;
                    }
                }

                return true;
            } catch (error) {
                alert(error.message);
                return false;
            }
        },
    },
    watch: {
        _program() {
            this.init();
        },
        _user() {
            this.init();
        },
        shows(shows) {
            if (shows) this.$nextTick(this.init);
            else if (this.updated) {
                this.$emit("input", this.form);
            }
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style lang="scss" scoped>
::v-deep .v-stepper__wrapper {
    display: flex;
    flex-direction: column;
}
</style>
